<nav *ngIf="workflow !== null; else stageFilter" class="ms-workflow" [attr.aria-label]="label">
  <button *ngFor="let step of workflow; let index = index" type="button" class="br-interactive ms-workflow-step"
          [attr.title]="step.label" [disabled]="step.disabled" [class.ms-viewed]="selected === step.id" [class.ms-complete]="step.complete"
          [attr.aria-current]="!closed && current === step.id ? 'step' : null"
          [attr.aria-label]="step.label + (step.complete ? ': complete' : closed ? ': incomplete' : current === step.id ? ': in progress' : ': upcoming')"
          (click)="view(step.id)">
    <span class="ms-workflow-dot" aria-hidden="true">{{ step.complete ? '✓' : index + 1 }}</span>
    <span>{{ step.label }}</span>
  </button>
</nav>
<ng-template #stageFilter>
<button type="button" class="ms-all" [class.selected]="isSelected(null)"
        (click)="choose(null)">
  <span class="ms-dotrow"><span class="ms-dot"></span></span>
  <span class="ms-label">{{ allLabel }} <span class="ms-count">({{ total }})</span></span>
</button>

<div class="ms-track">
  <button *ngFor="let stop of stops; trackBy: trackStop" type="button"
          class="ms-step" role="tab"
          [style.color]="stop.color || null"
          [attr.aria-selected]="isSelected(stop.id)"
          [class.selected]="isSelected(stop.id)"
          [class.empty]="!stop.count"
          (click)="choose(stop.id)">
    <span class="ms-dotrow"><span class="ms-dot"></span></span>
    <span class="ms-label">{{ stop.label }}
      <span class="ms-count">({{ stop.count }})</span></span>
  </button>
</div>

</ng-template>
